import React from 'react';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
import StatusModifier from './statusmodifier/StatusModifier';
import { useHistory } from 'react-router-dom';

export default function OrderRow(props) {
    let order = props.order;

    const history = useHistory();

    const isNisaOrder = order.supplierCode.startsWith('NISA');

    const setOnclickForSupplier = () => {
        if (isNisaOrder) {
            history.push('/order/' + order.id);
        } else {
            history.push('/bestway-transaction/' + order.depot + '/' + order.id);
        }
    };

    return (
        <tr onClick={setOnclickForSupplier}>
            <td>{order.supplierName}</td>
            <td className={'bold'}>{order.id}</td>
            <td>{order.retailerReference}</td>
            <td>
                {order.submittedDate ? (
                    <div>
                        <Moment format={'dddd'}>{order.submittedDate}</Moment>
                        <br />
                        <Moment format={'DD/MM/YYYY HH:mm'}>{order.submittedDate}</Moment>
                    </div>
                ) : (
                    `\u2013`
                )}
            </td>
            <td>
                {order.deliveryDate ? (
                    <div>
                        <Moment format={'dddd'}>{order.deliveryDate}</Moment>
                        <br />
                        <Moment format={'DD/MM/YYYY'}>{order.deliveryDate}</Moment>
                    </div>
                ) : (
                    `\u2013`
                )}
            </td>
            <td className={'right'}>{order.totalLines}</td>
            <td className={'right'}>{order.totalCases}</td>
            <td className={'bold right'}>
                <NumberFormat
                    value={order.totalCost}
                    displayType={'text'}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    prefix={'£'}
                />
            </td>
            <td className={'bold'}>
                <StatusModifier orderHeader={order} highlightOpen={true} />
            </td>
        </tr>
    );
}
